// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__UX4pf","modal-show":"Modal_modal-show__M2AIl","openModal":"Modal_openModal__R4+qP","modal-bg-show":"Modal_modal-bg-show__6gtnP"};